import { v4 } from "uuid";

/**
 * Формирует ключ из значений простого объекта
 *
 * @param {Object} filter
 * @param {string} prefix
 */
export const cacheKeyFromFilterObject = (filter, prefix = "") => {
  return (
    prefix +
    (Object.values(filter)
      .map(item => item || "")
      .join("") || "all")
  );
};

export const Utils = ctx => {
  return {
    /**
     * @returns {string}
     */
    uuid() {
      return v4();
    },

    /**
     * @param {Array} arr
     * @param {number} size
     * @returns {Array}
     */
    arrayChunk(arr, size) {
      return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
    },

    pluralForm(number, variants) {
      const cases = [2, 0, 1, 1, 1, 2];
      return variants[number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]];
    },
  };
};
